var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4787_39025)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.503906 4.24219C0.503906 3.74491 0.70145 3.26799 1.05308 2.91636C1.40471 2.56473 1.88163 2.36719 2.37891 2.36719H13.6289C14.1262 2.36719 14.6031 2.56473 14.9547 2.91636C15.3064 3.26799 15.5039 3.74491 15.5039 4.24219V11.7422C15.5039 12.2395 15.3064 12.7164 14.9547 13.068C14.6031 13.4196 14.1262 13.6172 13.6289 13.6172H2.37891C1.88163 13.6172 1.40471 13.4196 1.05308 13.068C0.70145 12.7164 0.503906 12.2395 0.503906 11.7422V4.24219ZM2.37891 3.30469C2.13027 3.30469 1.89181 3.40346 1.71599 3.57927C1.54018 3.75509 1.44141 3.99355 1.44141 4.24219V5.17969H14.5664V4.24219C14.5664 3.99355 14.4676 3.75509 14.2918 3.57927C14.116 3.40346 13.8775 3.30469 13.6289 3.30469H2.37891ZM14.5664 7.05469H1.44141V11.7422C1.44141 11.9908 1.54018 12.2293 1.71599 12.4051C1.89181 12.5809 2.13027 12.6797 2.37891 12.6797H13.6289C13.8775 12.6797 14.116 12.5809 14.2918 12.4051C14.4676 12.2293 14.5664 11.9908 14.5664 11.7422V7.05469Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.37891 9.86719C2.37891 9.61855 2.47768 9.38009 2.65349 9.20428C2.82931 9.02846 3.06777 8.92969 3.31641 8.92969H4.25391C4.50255 8.92969 4.741 9.02846 4.91682 9.20428C5.09263 9.38009 5.19141 9.61855 5.19141 9.86719V10.8047C5.19141 11.0533 5.09263 11.2918 4.91682 11.4676C4.741 11.6434 4.50255 11.7422 4.25391 11.7422H3.31641C3.06777 11.7422 2.82931 11.6434 2.65349 11.4676C2.47768 11.2918 2.37891 11.0533 2.37891 10.8047V9.86719Z",
    fill: "#4F4F4F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4787_39025"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(0.503906 0.492188)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCard);
export default __webpack_public_path__ + "static/media/icon-card.afe522ad258f5fd7dfb924a3e7135362.svg";
export { ForwardRef as ReactComponent };